import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { updateDiagramSpacing, getDiagramSpacing } from '@process-advisor/process-miner/processMiner/processMiner';

export type SpacingsProps = ApiMethodBase & {
    layer: number;
    column: number;
};

export const setSpacings = ({
    diagram,
    column,
    layer,
}: SpacingsProps) => {
    diagram.layout.layerSpacing = layer;
    diagram.layout.columnSpacing = column;
    updateDiagramSpacing({layer, column});
};


export const getSpacings = (): SpacingsProps => getDiagramSpacing();
